import React, { Fragment } from 'react';
import InteractiveItem from './InteractiveItem';
import Carousel from '../Carousel/Carousel';

const InteractiveList = ({ list }) => {
  const items = list
    .filter(({ Description }) => Description !== null)
    .map(({ Description, MediaUrl, LinkUrl }, i) => (
      <InteractiveItem
        key={i}
        description={Description}
        mediaUrl={MediaUrl}
        linkUrl={LinkUrl}
      />
    ));

  return (
    <Fragment>
      <div className="container">
        <div className="carousel-content">
          <Carousel itemsPure={items} items={items} dotsDisabled={true} />
        </div>
      </div>
    </Fragment>
  );
};

export default InteractiveList;
